<template>
  <div>
    <router-link
      to="/login"
      class="inline-flex items-center p-2 text-center text-white hover:text-gray-500 hover:bg-gray-200 rounded-md"
    >
      <em class="fa-solid fa-arrow-left mx-auto"></em>
    </router-link>
  </div>
</template>
